<template>
  <div class="page-wrap">
    <oHead :white="true"></oHead>
    <animationWrap @current="(newV)=>{this.currentModule = newV}">
      <swiper class="banner-swiper" @mouseenter.native="swiperEnter('bannerSwiper')" @mouseleave.native="swiperLeave('bannerSwiper')" :options="bannerOption" ref="bannerSwiper">
        <swiper-slide class="banner-item" v-for="(item,ind) of swiperList" :key="ind">
          <div class="banner-img" :style="{backgroundImage: `url(${item.imgUrl})`}">
            <Transition enter-active-class="animate__animated animate__bounceInDown">
              <div class="content" v-if="currentModule > 0">
                <div class="title">{{item.title}}</div>
                <div class="sub-title">{{item.subTitle}}</div>
                <div class="desc">{{item.desc}}</div>
                <div class="w-btn small" @click="consultVisible = true">产品咨询</div>
              </div>
            </Transition>
          </div>
        </swiper-slide>
      </swiper>
      <moduleWrap
        class="effect-wrap"
        :active="currentModule>0"
        title="产品功能"
        bgCol="#ffffff"
        :subTitleV="false"
      >
        <div class="effect-slot">
          <Transition enter-active-class="animate__animated animate__bounce">
            <div class="effect-inner" v-if="currentModule>0">
              <div
                class="effect-item"
                :style="{backgroundImage: `url(${effectBgList[ind]})`}"
                v-for="(item, ind) in effectList"
                :key="ind"
              >
                <div class="effect-name">{{item.name}}</div>
                <div class="effect-desc" :title="item.desc">{{item.desc}}</div>
              </div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <moduleWrap
        :active="currentModule>1"
        title="产品特点"
        bgImg="/img/product/bg09@2x.png"
        :subTitleV="false"
      >
        <div class="characteristic-slot">
          <Transition enter-active-class="animate__animated animate__bounceInRight">
            <div v-if="currentModule>1" class="characteristic-content">
              <div class="char-item" v-for="(item,ind) in characteristicData" :key="ind">
                <img width="100" height="100" :src="item.imgUrl" alt />
                <div class="char-name">{{item.name}}</div>
                <div class="char-desc">{{item.desc}}</div>
              </div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <moduleWrap :active="currentModule>2" :subTitleV="false" title="应用场景" bgCol="#fff">
        <div class="scene-slot">
          <Transition enter-active-class="animate__animated animate__bounceInRight">
            <div class="scene-wrap" v-if="currentModule>2">
              <div
                class="scene-item"
                v-for="(scene,index) in sceneData"
                :key="index"
                :style="{backgroundImage: `url(${scene.imgUrl})`,width:scene.width+'px'}"
              >
                <div class="linear"></div>
                <img :src="scene.icon" width="40" height="40" alt />
                <div class="scene-name">{{scene.name}}</div>
              </div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <moduleWrap
        :active="currentModule>3"
        title="优秀案例"
        bgImg="/img/product/bg07@2x.png"
        :subTitleV="false"
      >
        <div class="case-slot">
          <Transition enter-active-class="animate__animated animate__bounceInRight">
            <div class="case-wrap" v-if="currentModule>3">
              <div class="inner">
                <div class="inner-right">
                  <swiper class="case-swiper" :options="caseOption" ref="mySwiper">
                    <swiper-slide
                      class="case-item"
                      v-for="(item,ind) of caseData.caseSwiper"
                      :key="ind"
                    >
                      <div class="case-img">
                        <Transition enter-active-class="animate__animated animate__bounceInDown">
                          <div class="content" v-if="currentModule > 3">
                            <div class="img">
                              <img :src="item.imgUrl" width="80" height="80" alt />
                            </div>
                            <div class="case-right">
                              <div class="title">{{item.title}}</div>
                              <div class="desc">{{item.desc}}</div>
                              <div class="item-btn" @click.stop="jumpTo(item)">
                                查看详情
                                <i class="iconfont arrowright"></i>
                              </div>
                            </div>
                          </div>
                        </Transition>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </moduleWrap>
      <oFoot :active="currentModule>4"></oFoot>
    </animationWrap>
    <Transition
      enter-active-class="animate__animated animate__pulse"
      leave-active-class="animate__animated animate__fadeOut"
    >
      <consulting v-if="consultVisible" :dialog="true" @close="consultVisible=false"></consulting>
    </Transition>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import consulting from '@/components/consulting.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import moduleWrap from '@/components/moduleWrap.vue'
import oHead from '@/components/header.vue'
import oFoot from '@/components/footer.vue'
import animationWrap from '@/components/animationWrap.vue'
import { jumpTo } from '@/util.js'

export default {
  components: {
    swiper,
    oHead,
    swiperSlide,
    moduleWrap,
    consulting,
    animationWrap,
    oFoot,
  },
  data() {
    return {
      consultVisible: false,
      currentModule: 0,
      //产品功能背景图
      effectBgList: [
        '/img/product/bg_product07.png',
        '/img/product/bg_product08.png',
        '/img/product/bg_product09.png',
        '/img/product/bg_product10.png',
        '/img/product/bg_product11.png',
        '/img/product/bg_product12.png',
      ],
      // 详情数据信息（产品功能effectList中imgUrl无效，改为effectBgList数组随机生成）
      productData: {
        //水库雨水情在线测报平台
        skysq: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner02@2x.png',
              title: '智慧水利',
              subTitle: '水库雨水情在线测报平台',
              desc: '水库雨水情在线测报平台通过前端物联设备实现实时雨情、水情情况的自动化采集，同时利用深度算法，基于历史水位、雨量、流量信息，对水库的水位、库容量、蓄水量进行进行模拟预测，助力水库的防洪形势决策',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '雨情信息测报',
              desc: '雨情信息的在线自动监测，根据不同降雨情况自动生成告警信息',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '水情信息测报',
              desc: '在水位在线自动监测基础上，联动现场视频AI读取现场水尺信息',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '库容动态模拟',
              desc: '提供专业库容分析模型，智能分析水库的可用库容和蓄水率情况',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '雨水情分析简报',
              desc: '支持一键自动生成水库的雨水情简报，为领导决策提供参考依据',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '视频AI联动',
              desc: '通过前端视频监控，结合计算机视觉AI算法，实现现场情况的自动化联动录制以及水尺信息的自动读取，可配套辅助确认现场实时水位情况',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '库容模拟深度算法',
              desc: '针对主暴雨来临前、中、后三种情景，可通过专业的计算模型，进行在线分析计算，为洪涝灾害防御提供科学辅助',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '自动化雨水情报告',
              desc: '支持用户自定义时段，设定完成后，系统一键自动生成雨水情报告，无需人工进行制作，大大提高工作效率',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '智慧水库',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '应急调度',
            },
            {
              imgUrl: '/img/product/img04@2x.png',
              icon: '/img/product/icon04@2x.png',
              name: '防汛指挥',
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '/caseDetail/dhsk',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //水库大坝安全监测平台
        skdbaq: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner02@2x.png',
              title: '智慧水利',
              subTitle: '水库大坝安全监测平台',
              desc: '水库大坝安全监测平台通过对大坝表面变形、渗流、渗压等异常情况进行自动监测，通过建立水位和位移、渗流量、浸润线的对应关系，结合人工智能算法模型分析大坝安全情况，对大坝的安全情况自动生成报告及评级管理，助力水库大坝安全智能监管。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '大坝变形监测',
              desc: '大坝变形监测实现对大坝水平和垂直的位移变化情况，结合告警模型，对大坝安全进行自动的测报告警。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '大坝渗流监测',
              desc: '通过对大坝渗流情况的监测，建立起来不同水位情况下大坝渗流量的对应关系曲线，当曲线异常时自动化告警。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '大坝渗压监测',
              desc: '根据大坝不同监测点位的监测数据，由系统自动绘制水库的浸润曲线，让管理人员直观掌握大坝的渗压情况。',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '大坝安全检测报告',
              desc: '建立大坝安全评估模型，根据表面变形情况、大坝渗流情况、大坝渗压情况等自动对大坝安全进行评估并生产报告。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product04.png',
              name: '远程自动监测',
              desc: '实时掌握渗流量、渗流压力、表面形变等安全关键指标实时数据，自动生成各类数据过程曲线和报表。',
            },
            {
              imgUrl: '/img/product/icon_product05.png',
              name: '自动告警通知',
              desc: '支持灵活告警规则配置，支持根据不同的大坝类型设置不同告警规则，并自动产生告警并向责任人发送报警信息。',
            },
            {
              imgUrl: '/img/product/icon_product06.png',
              name: '大坝安全评估',
              desc: '大坝安全系数自动评估，定期自动生成大坝安全评估报告，让水库管理人员及时掌握水库的安全情况。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '智慧水库',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '应急调度',
            },
            {
              imgUrl: '/img/product/img04@2x.png',
              icon: '/img/product/icon04@2x.png',
              name: '防汛指挥',
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //水资源综合管理平台
        szyzhgl: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner02@2x.png',
              title: '智慧水利',
              subTitle: '水资源综合管理平台',
              desc: '水资源综合管理平台汇集涉水大数据，构建水资源智能应用，建成功能完备的水资源业务应用体系，支撑形成水资源开发利用管控、全流程业务联动。通过“数字赋能”为现代水网体系实现“多源互补、丰枯调剂、环境优美”提供有力支撑与强力驱动。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '感知智慧',
              desc: '利用物联网、自动控制等技术,实现对涉水信息资源进行全面准确的实时监测，形成强大的水环境物联网。',
            },
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '认知智慧',
              desc: '利用机器视觉分析、深度学习等技术,实现对河湖视频图像资源的结构化分析,提升发现问题、定位问题、分析问题的综合水平。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '管理智慧',
              desc: '利用大数据、云计算等技术，对传统河湖的全领域进行智能化管理，切实提高河湖建设和管理水平',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '服务智慧',
              desc: '促进水环境现代化，并充分利用新一代信息技术，将这种支撑保障和水环境科技文化为社会公众提供定制服务。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product07.png',
              name: '“兼容”硬件资产',
              desc: '视频监控设备、无人机等硬件设备厂商跨时期、多厂商建设，缺乏整合，导致管理混乱，通过本方案可协助客户全面整合已建/新建硬件资产。',
            },
            {
              imgUrl: '/img/product/icon_product08.png',
              name: '“唤醒”视频资源',
              desc: '许多监测站、排污口、河道等水环境都建设有视频监控系统，并进行前端存储，通过本方案可实现有价值的视频资源自动提取并永久保存。',
            },
            {
              imgUrl: '/img/product/icon_product09.png',
              name: '“告别”人工模式',
              desc: '巡河员巡河、后台监控人员24查看视频等人工监管方式无法达到全面、有效、实时的监控，通过本方案可实现水环境全天候无人值守。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '智慧水库',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '应急调度',
            },
            {
              imgUrl: '/img/product/img04@2x.png',
              icon: '/img/product/icon04@2x.png',
              name: '防汛指挥',
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //河湖智慧管理平台
        hhzhgl: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner02@2x.png',
              title: '智慧水利',
              subTitle: '河湖智慧管理平台',
              desc: '实现河流水系全覆盖，视频监控应急联动，集成水质、水位监测数据，辅助河湖长实时掌握河湖态势,事件快速处置，推动水生态环境保护，河湖可视化、智能化治理，数字赋能助力幸福河湖迭代提升。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '河湖档案管理',
              desc: '对河湖水系路网的基础信息及河湖前端布设的感知设备信息，建立统一的维护管理，形成一湖一档、一河一档。',
            },
            {
              imgUrl: '/img/product/bg_product08.png',
              name: '四乱问题台账',
              desc: '通过构建河湖智能视频监控网络，结合视频AI算法，对河湖的周边的“乱采”、“乱占”、“乱堆”、“乱建”四乱问题进行自动识别并形成台账。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '日常巡查管理',
              desc: '提供日常巡查管理功能，建立起来实时监测、告警、推送、办理、反馈、调度的全流程的闭环管理机制。',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '治理成效报告',
              desc: '根据河湖的治理目标，根据四乱问题的台账及治理成效，自动形成治理成效报告，辅助决策指挥。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product10.png',
              name: 'AI智能识别',
              desc: '提供AI模型能力，实现垃圾乱堆乱放、违法私搭乱建房屋、违法种植养殖、涉河违建、非法围河围湖、非法堆弃和填埋固体废物等四乱场景的识别。',
            },
            {
              imgUrl: '/img/product/icon_product11.png',
              name: '视频动态联动',
              desc: '当通过AI识别到四乱场景时，自动联动前端感知摄像头，自动进行取证，实现由“事后被动应对”向“事前主动预防”转变。',
            },
            {
              imgUrl: '/img/product/icon_product12.png',
              name: '自动化报告',
              desc: '由系统自动生成治理周报，对各地问题核查处置情况进行排名通报，配套激励问责机制，实现定期通报，形成常态化治理，持续改善河湖面貌。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img08@2x.pn',
              icon: '/img/product/icon07@2x.png',
              name: '水资源保护',
            },
            {
              imgUrl: '/img/product/img07@2x.png',
              icon: '/img/product/icon05@2x.png',
              name: '河湖清“四乱”',
              width: 1200
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //山洪灾害防御指挥平台
        shzhfw: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner02@2x.png',
              title: '智慧水利',
              subTitle: '山洪灾害防御指挥平台',
              desc: '结合降雨雷达观测系统、实时监测降雨数据和气象精细化短临降雨预报数据为驱动，并结合遥感观测、动态预警分析等先进技术，实现山区小流域短历时洪水快速预报预警，有效提升山洪预警的时效性和精确性，保障工程运行管理安全，有效支撑山洪防控决策。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '山洪预警模型',
              desc: '以实时降雨、实时土壤含水量和降雨重现期指标为依据，根据风险等级划分标准，建设整体形势山洪风险预警分析模型。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '山洪预报分析',
              desc: '实现山洪整体形势和沿河村落的山洪风险预报分析，自动开展沿河村落的山洪预报预警分析，当超过转移预警阀值时，触发转移预警、提供转移路线。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '山洪灾害预警发布',
              desc: '提供新预警（出现预警）→内部预警（对水旱灾害防御人员）→外部预警（对社会公众）→响应启动→响应结束的全流程闭环管理。',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '山洪分析简报',
              desc: '平台结合水旱灾害防御实际需求，自动生成分析简报，简报内容包括山洪风险总体研判、山洪预警详细信息等。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product12.png',
              name: '预报模型',
              desc: '建立预报模型，整合气象、降水、下垫面、温度、湿度等不同的维度进行综合评估，对山洪进行预报。',
            },
            {
              imgUrl: '/img/product/icon_product05.png',
              name: '预警闭环',
              desc: '形成从预测、预报、预警、预案的四预机制，构建起来了山洪预警的闭关管理策略，辅助山洪灾害防御。',
            },
            {
              imgUrl: '/img/product/icon_product15.png',
              name: '分析简报',
              desc: '以文字、图片、表格等多种表现形式综合展示未来一定时段内的风险预警信息，形成分析简报。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img13@2x.png',
              icon: '/img/product/icon04@2x.png',
              name: '山洪防汛',
            },
            {
              imgUrl: '/img/product/img12@2x.png',
              icon: '/img/product/icon11@2x.png',
              name: '雨水情监测',
              width: 384,
            },
            {
              imgUrl: '/img/product/img11@2x.png',
              icon: '/img/product/icon09@2x.png',
              name: '预警管理',
              width: 384,
            },
            {
              imgUrl: '/img/product/img10@2x.png',
              icon: '/img/product/icon10@2x.png',
              name: '应急管理',
              width: 384,
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //城乡供水一体化平台
        cxgsyth: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner01@2x.png',
              title: '智慧水务',
              subTitle: '城乡供水一体化平台',
              desc: '平台充分运用“互联网+”手段，着力提升城乡供水领域数字治水的能力和水平，使供水工程“全域覆盖、全网共享、全时可用、全程可控”成为可能，打造了城乡供水统筹谋划、一体推进、均等服务、全民受益的高质量发展新格局。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '管系GIS',
              desc: '将泵房、站点水厂等在GIS地图上散点，并展示基础信息，通过GIS图层对不同类型的站点和设备用不同图层进行管理。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '供水调度一张图',
              desc: '展示各行政区域的供水信息、预警分析、监测数据等内容，让管理者直观、快速的了解整个供水体系，为决策提供依据。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '监测分析',
              desc: '通过城乡供水一体化监测系统的建设，实现管网重点区域、泵站、末端等实时监测，分析城乡供水整体运行情况，保障供水管网正常。',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '手机APP',
              desc: '支持定期巡检，并展示监测数据、预警通知、任务通知和工单处理，掌上监管，灵活方便。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '供水管网一张图',
              desc: '结合GIS地图应用，展示管网分布情况及重要的泵房、站点的基本信息、水质、流量、压力、阀门等设备的实时监测数据。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: 'DMA漏损溯源',
              desc: '基于DMA分区，结合夜间最小流量等相关算法，对管网产生的漏损情况进行综合分析判断，并自动产生预警。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '预警预报管理',
              desc: '针对流量、压力、声纹等前端监控设备设置报警阈值和报警方案，自动实现数值异常时通过平台界面、短信、APP等渠道发送报警信息。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '智慧水务',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧供水',
            },
            {
              imgUrl: '/img/product/img03.png',
              icon: '/img/product/icon03@2x.png',
              name: '农村饮用水管网',
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //污水管网智慧监管系统
        wsgwzhjg: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner01@2x.png',
              title: '智慧水务',
              subTitle: '污水管网智慧监管系统',
              desc: '污水管网智慧监管系统利用物联网技术、数据通信技术、地理信息技术、视频处理技术等，建立全面的信息管理、环境保护监测系统，及时发现并解决雨水混入污水、污水偷排、错排、漏排、管网破损淤堵及城市内涝等问题。有利于提升污水处理设施的运维效率和标准化水平，改善人居环境和生态环境。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '多种感知设备',
              desc: '结合网管实际情况进行专业的安装方案设计，大多设备采用微功耗设计，既能内置电池供电又可外接供电，使用寿命长，安装简单、维护方便。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '污水管网“一张图”',
              desc: '运用GIS技术构建污水排水管网管线规划分析系统、静态沙盘等，实现多维度直观展示排水系统。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: 'APP巡检',
              desc: '通过手机APP同步监测、查询数据、接收报警、提高巡检效率，便于及时发现报警信息并处理管网故障。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '污水管理可视化',
              desc: '以BIM技术为支撑，绘制三维立体式污水排水管网动态“一张图”，全局透视城市污水管网，全方位、多角度、多元化动态展示地理信息空间分布。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '全程管理自动化',
              desc: '运用感知监测网、物联网、移动互联网等现代信息技术为核心，对水质监测、污水管网、作业人员等多源实时数据进行融合，实现24小时全自动化管理。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '统计分析智能化',
              desc: '智能分析数据变化趋势，图表形式展示，按客户需求生成日、月、年度报表，提高管理效率。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '市政排水/污水监测',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水务',
            },
            {
              imgUrl: '/img/product/img03.png',
              icon: '/img/product/icon03@2x.png',
              name: '企业/园区排水监测',
            },
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '智慧城市',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧管网',
              width: 1200
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //城市排水防涝平台
        cspsfl: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner01@2x.png',
              title: '智慧水务',
              subTitle: '城市排水防涝平台',
              desc: '城市排水防涝平台针对雨、污水排水全流程进行监控管理，及时预警内涝，科学排水调度，诊断排水管网健康状况，以便快速采取防灾减灾措施，减少人民生命财产损失。帮助相关管理部门掌握城市排水数据，为评估城市排水能力、消除内涝提供科学依据，提升排水行业现代化管理水平，推动全社会的水安全。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: 'GIS地图展示',
              desc: '在电子地图上显示城市易涝点现场位置信息、基础信息、实时状态等。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '实时监测告警',
              desc: '实时监测各个易涝点积水液位高度，根据预先设定的报警规则，对现场液位异常情况进行实时告警监测，并支持对不同等级告警。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '视频图像监测',
              desc: '在易涝积水点附近安装摄像设备，对积水点区域内涝产生及消除过程中的实时积水情况及对周边环境的影响进行图像和视频采集，直观地反应内涝全过程。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '可视化数据管理',
              desc: '结合GIS地图展示城市排水防涝系统等实时数据，并在可视化界面上实现完整防汛排涝的管理闭环，为城市防汛提供坚实的技术保证。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '全过程综合监管',
              desc: '实时监测排水防涝信息，打造“感知-传输-监测-预警-撤离”的完整防汛排涝的管理闭环，保证监管的力度与质量。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '排水防涝智能分析',
              desc: '平台结合排水防涝的实际需求，多样化的数据统计分析成果，为排水能力评估、防汛指挥调度、基础设施改造提供辅助支撑工具。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '城市排水管理',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img03.png',
              icon: '/img/product/icon03@2x.png',
              name: '防汛预警',
              width: 1200
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //灌区信息化管理平台
        gqxxhgl: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner01@2x.png',
              title: '智慧水务',
              subTitle: '灌区信息化管理平台',
              desc: '灌区信息化管理平台主要包括水情信息采集与监测、闸门自动控制、水闸和渠道安全监测、视频监控、应急调度、灌溉水资源配置模型与用水管理决策支持、远程WEB查询等组成。该系统的应用能确保灌区的管理的安全运行，提高管理人员效率，提高水资源优化配置及用水效率发挥重要的作用。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '“一张图”灌区管理',
              desc: '以GIS地图为蓝本，聚合基础地形图、、灌溉面积分布图、水雨工情监测分布图、水资源红线图、遥感影像图等多源信息的地图，叠加灌区水资源及工程管理等业务管理系统，构建灌区综合监管“一张图”。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '运维中心系统',
              desc: '对工程维护管理和站点维护管理两大块，对工程巡检、平台预警、人工巡检反馈的异常状况进行录入、审核、指派、维护、费用、确认等，实现灌区建筑物、站点维护信息化管理和值班安排。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '移动端便捷管理',
              desc: '移动智能终端通过对水情监测、闸门控制、视频监控等前端感知设备，实现对水雨情监测、配水指令、用水计时证、图像采集等数据操作，为灌区工作人员与用水户提供方便快捷的信息服务。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '实时监控管理',
              desc: '实时监视取水泵站、提升泵站、电站、闸门的现场图像，自动监测用水户的用水量和计量仪表状态。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '远程控制管理',
              desc: '远程控制或自动控制闸门泵组启、停，远程控制闸门启、闭或闸门开度、监测水池或渠道的实时水位雨量，水位过高或过低自动报警。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '数据整合管理',
              desc: '灌区综合数据库设计采取地理空间数据库技术，将灌区水情数据，工情数据，工情信息与地理空间点、线、面相结合，建立一个完整的多层次的灌区空间数据库。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '雨水情监测',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '农业农田管理',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '水资源管理',
            },
            {
              imgUrl: '/img/product/img03.png',
              icon: '/img/product/icon03@2x.png',
              name: '灌区信息化管理',
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //智慧环保管理平台
        zhhbgl: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner04@2x.png',
              title: '智慧环保',
              subTitle: '智慧环保管理平台',
              desc: '基于福建省生态环境厅生态云系统底座，结合高精度的GIS地图引擎，依托生态环境数据资源中心，整合自建业务系统，实现生态环境数据的集中汇总，统一展示，打造水环境、大气环境、移动执法执法、信访管理、污染源自动监控、污染源视频管控、企业用电监控等多个业务主题一图呈现、一键检索，为决策依据提供准确、直观的参考依据。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '任务协同',
              desc: '问题预警、成因分析、指挥调度、督查督办”闭环管理，多部门、跨区域协同办理任务。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '省市级数据对接',
              desc: '全省一盘棋、省市县三级一体化融合，数据互通互享，高效协调监管，助力打赢好污染防治攻坚战。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '决策支持',
              desc: '全流程闭环监管运营模式，将治理的结果进行直观的对比展示，形成“统一调度、协同高效”的综合常态化体系，有效支撑业务管理和综合决策。',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '报告导出',
              desc: '定期自动生成治理成果评估报告，对治理成效进行分析展示，配套激励问责机制，定期通报，形成常态化治理，持续改善生态环境。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '一屏统管',
              desc: '借助可视化分析手段，动态更新，实时汇总，支持专题页面自行切换，以GIS地图加图表的形式帮助领导随时随地全面、直观地了解全市环境质量整体状况、变化趋势及各项工作的进展情况，及时发现环境问题，便于管理部门快速、精准掌控全局。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '省市级数据对接',
              desc: '全省一盘棋、省市县三级一体化融合，数据互通互享，高效协调监管，助力打赢好污染防治攻坚战。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '智慧环保',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧生态',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '环境管理',
              width: 1200
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //固危废AI监管平台
        gwfjg: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner04@2x.png',
              title: '智慧环保',
              subTitle: '固危废AI监管平台',
              desc: '通过建立固危废全流程监管体系实现对固废危废产生、收集、贮存、运输（转移）、处置全生命周期管理。利用物联网、大数据智能分析等技术，集成智能计重设备、视频监控设备、RFID/二维码识别、GIS/车辆监控、业务信息化、智能化、科学化管理水平。构建各产废企业、运输企业、处置企业大数据可视化，智能化建设，实现危险废物生产，收集，存储，转移，利用，处置等重点环节，重要场所智能监控规范化，标准化，集约化建设，实现互联互通，智能转化，完善智能化监控系统，切实提供固危废环境管理水平和效率。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '现场监控可视化',
              desc: '通过前端设备实现实时视频监控，目标监测、行为监测实时解析，并生成相应的预警信息。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '关键环节事件场景标注',
              desc: '对固危废全过程生产、贮存、运输、处置的事件场景进行标注，并备注点位、事件、单位、固废类型等信息。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '固危废管理“智能化”',
              desc: '平台支持对生产环节、贮存环节、运输环节等环节进行数据智能监管。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '关键事件与系统数据对比分析',
              desc: '通过结构化的视频数据对系统填报的数据进行佐证比对分析，并支持对产废集中入库、非法转移、非法处置等情况进行预警。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '“看得到”',
              desc: '实现固危废从产废、贮存、转移、利用处置等的全过程可视化监控。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '“查得准”',
              desc: '主动发现异常、视频取证，通过核查固废信息、视频录像，核实异常报警事件。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '“搞得清”',
              desc: '助力“产废有记录、贮存可查询、流向可追溯、责任可追究”的监管闭环。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '“管得好”',
              desc: '打造固危废从产生到打包转运，从称重、贴标入库，再到扫描转移、利用处置的一站式精细化管理。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '企业固危废管理',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '医院危废管理',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '生态环保',
              width: 1200
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //农村生活污水智慧监管平台
        ncshws: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner04@2x.png',
              title: '智慧环保',
              subTitle: '农村生活污水智慧监管平台',
              desc: '农村生活污水智慧监管为各个农村生活污水处理设施站点提供智能化监控及运维巡查管理功能；对设施运行与运维进行整体监管，提供考核评价功能，助力农村生活污水处理设施开启智慧监管新模式。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '设备联网',
              desc: '支持各级监管部门及企业不同平台、不同厂商、不同型号、不同组网、不同时期前端感知设备接入和联网。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '内容结构化',
              desc: '通过海量的监测数据结合业务数据，运用人工智能、大数据等技术手段，把视频转换成数据资产，让数据迸发出新的活力。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '智能运维',
              desc: '实现对设备点位、资源目录组织、视频数据、场景分类、设备状态、事件等的管理，构建统一的视频资源描述规范。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '智能告警',
              desc: '利用视频AI技术有效提取水质监测因子、站房值守等要素特征，识别违规行为并取证，实现全天候无人值守监控预警。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '设备运行监控',
              desc: '应用物联网和信息化等非现场监管手段，开展农村生活污水处理设施分类监测、监控工作，设备运行监测监控模块提供运行监控、视频监控、工单设施透视、趋势分析。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '视频AI检测告警',
              desc: '利用视频AI技术有效提取水质监测因子、站房值守等要素特征，识别违规行为并取证，实现全天候无人值守监控预警。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '多维度监管考核',
              desc: '对所管理单位或人员的考核管理，可以按照各项考核项目，进行自动数据分析、人工填报及现场抽查等各项考核工作；同时支持对运维机构与队伍管理运营管理。',
              width: 1200
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '智慧水利',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '农村环境管理',
            },
            {
              imgUrl: '/img/product/img04@2x.png',
              icon: '/img/product/icon04@2x.png',
              name: '污水管理',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '生态环境治理',
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //大气治理信息化监管平台
        dqzlxxh: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner04@2x.png',
              title: '智慧环保',
              subTitle: '大气治理信息化监管平台',
              desc: '大气治理信息化监管平台以地市现有的业务系统数据和政数局的服务器与网络资源作为基础，汇聚各类大气相关的数据，形成数据资源中心，结合各类技术模型与管控方案，打造“发现问题——分析问题——污染溯源——管调度管控——减排评估”应用场景，提升地市生态环境的管控指挥能力。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '视频AI监测',
              desc: '训练大气污染防控场景专用视频AI算法，建设从自动发现到自动预警、自动记录、自动下发防控工单的智能防控模式。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '大气环境综合看板',
              desc: '实现空气质量GIS地图信息综合的查看，空气质量情况展示、空气质量达标测算展示等多项业务综合信息，以一张图的形式，把本市大气状况简洁、客观、真实、及时地呈现出来。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '大气污染分析研判',
              desc: '利用站点空气质量数据、空气质量预报数据和超站组分监测数据等，实时监控空气质量现状，精准研判大气污染的形势。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product01.png',
              name: '视频资源管理',
              desc: '整合地市已建、待建大气环境相关视频监控资源，对接入的视频资源进行统一的资料完善和标签治理，将视频点位铺设在综合看板子系统的GIS地图上。',
            },
            {
              imgUrl: '/img/product/icon_product02.png',
              name: '智能分析研判',
              desc: '预报与溯源分析针对污染站点，建立扩散叠加模型和溯源分析模型，预测污染物排放强度和不同天气条件下污染物的时空分布，分析不同污染源对环境质量的影响。',
            },
            {
              imgUrl: '/img/product/icon_product03.png',
              name: '防控调度管理',
              desc: '根据污染溯源分析结果，结合污染源实时排污状况，通知监管单位进行防控调度，要求关联企业按照平台下发的管控措施进行问题整改或排查处理，实现污染的动态监管。',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '生态环境',
            },
            {
              imgUrl: '/img/product/img02@2x.png',
              icon: '/img/product/icon02@2x.png',
              name: '大气环境治理',
            },
            {
              imgUrl: '/img/product/img03@2x.png',
              icon: '/img/product/icon03@2x.png',
              name: '城市生态环境治理',
              width: 1200
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
        //海洋环境综合管理平台平台
        hpljzhzl: {
          //产品概述
          swiperList: [
            {
              imgUrl: '/img/product/banner04@2x.png',
              title: '智慧环保',
              subTitle: '海洋环境综合管理平台',
              desc: '以改善区域海洋生态环境质量为核心，综合运用卫星遥感、无人机、视频监控、海上自动浮标站等空天地海智能感知手段，实现重点直排海污染源污水和尾水排放监测、入海排污口分类整治、海漂垃圾智慧监管、“美丽海湾”精细化单元管控和全天候可视化监管，全面支撑重点海域污染防治攻坚战，强化陆域海域污染协同治理，打好海洋环境综合管理平台攻坚战，推进“美丽海湾”保护与建设。',
              btn: 'contact',
            },
          ],
          //产品功能
          effectList: [
            {
              imgUrl: '/img/product/bg_product01.png',
              name: '天地一体化感知层',
              desc: '运用卫星遥感、无人机，精准、快速的发现海岸带垃圾分布情况，依托智能摄像头实现重点岸段全天候监控，打造“天地一体化”的海漂监测体系。',
            },
            {
              imgUrl: '/img/product/bg_product02.png',
              name: '海漂垃圾智能识别',
              desc: '通过已建或者新建的视频监控系统的全天候监控数据，基于深度学习和图像视觉分析技术，对塑料、瓶子、橡胶、轮胎、木头、废物、泡沫等海漂垃圾进行监测、识别、预警及分析。',
            },
            {
              imgUrl: '/img/product/bg_product03.png',
              name: '自动生成治理报告',
              desc: '提取海漂垃圾类型、垃圾覆盖面积、清扫结果和点位，自动化生成海漂垃圾治理日报、周报、月报，推到海漂垃圾形成常态化监管。',
            },
            {
              imgUrl: '/img/product/bg_product04.png',
              name: '多屏互动精准调度',
              desc: '运用电脑、一张图、手机APP等界面，在信息化平台上实现数据信息可视化、预警调度智能化、操作模式简易化、后台管理高效化，大幅提高海上环卫队伍工作效率，达到精准管控效果。',
            },
          ],
          //产品特点
          characteristicData: [
            {
              imgUrl: '/img/product/icon_product16.png',
              name: '天上“巡”',
              desc: '卫星遥感、无人机航拍大尺度发现',
            },
            {
              imgUrl: '/img/product/icon_product17.png',
              name: '岸上“盯”',
              desc: '重点海湾部署视频监控小尺度持续监管',
            },
            {
              imgUrl: '/img/product/icon_product18.png',
              name: '云上“管”',
              desc: '云平台动态分析、科学研判，实时调度、精准管控',
            },
            {
              imgUrl: '/img/product/icon_product19.png',
              name: '掌上“清”',
              desc: '手机APP接收任务上传清扫结果',
            },
          ],
          //应用场景
          sceneData: [
            {
              imgUrl: '/img/product/img14@2x.png',
              icon: '/img/product/icon14@2x.png',
              name: '海洋生态管理',
            },
            {
              imgUrl: '/img/product/img15@2x.png',
              icon: '/img/product/icon15@2x.png',
              name: '海岸线环境管理',
            },
            {
              imgUrl: '/img/product/img16@2x.png',
              icon: '/img/product/icon16@2x.png',
              name: '河湖环境管理',
            },
            {
              imgUrl: '/img/product/img01@2x.png',
              icon: '/img/product/icon01@2x.png',
              name: '水库环境管理',
            },
          ],
          //优秀案例
          caseData: {
            intro: {
              imgUrl: '/img/product/img05@2x.png',
              name: '万福信息，为您提供 专业化方案',
              children: [
                {
                  name: '专业',
                },
                {
                  name: '全面',
                },
                {
                  name: '高效',
                },
              ],
            },
            caseSwiper: [
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
              {
                imgUrl: '/img/product/icon_product01.png',
                title: '德化县小型水库雨水情测报和大坝安全监测项目',
                desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
                path: '',
              },
            ],
          },
        },
      },
      // banner
      swiperList: [],
      effectList: [],
      characteristicData: [],
      sceneData: [],
      caseData: {
        intro: {
          imgUrl: '/img/product/img05@2x.png',
          name: '万福信息，为您提供 专业化方案',
          children: [
            {
              name: '专业',
            },
            {
              name: '全面',
            },
            {
              name: '高效',
            },
          ],
        },
        caseSwiper: [
          {
            imgUrl: '/img/case/case1.png',
            title: '德化县小型水库雨水情测报和大坝安全监测项目',
            desc: '本项目通过对德化红洋水库、隆泰水库、红星水库、东风水库的水位、雨量、大坝安全、视频等前端感知设备的升级和补充，实现将乐水库物联感知全覆盖，感知能力得到显着提升；同时打造 AI 智能识别等重…',
            path: '/caseDetail/dhsk',
          },
          {
            imgUrl: '/img/case/case2.png',
            title: '罗源南门溪、起步溪水环境综合整治项目',
            desc: '本项目是罗源县民办实事项目之一，项目工程主要分为：1、截污工程；2、清淤工程；3、闸坝改造；4、景观工程；5、物联网工程。本项目充分利用物联网+AI技术，在多个应用场景中利用到人工智能技术。',
            path: '/caseDetail/lynmx',
          },
          {
            imgUrl: '/img/case/case3.png',
            title: '泉州市市政信息化项目',
            desc: '泉州市政信息化系统是由四个项目组成的全方位、立体化的监测网以及集网络、数据库、地理信息技术于一体的综合、全面的业务信息平台管理体系，为泉州市市政工程中心正常业务的开展提供了强有力支撑，为防灾减灾提供了强有力保障。项目包括泉州市政监控调度指挥软件平台（含APP）、泉州市政防洪排涝管理系统、视频监控系统、运维管理记录平台以及智控中心。',
            path: '/caseDetail/qzsszxxh',
          },
          {
            imgUrl: '/img/case/case4.png',
            title: '晋江生态环境一张图',
            desc: '全省第一个基于生态云总体系统框架，打造的具有晋江特色的业务应用系统，可实现污染源自动监控、河道水质自动监控、污染源视频监控、企业用电监控、信访件办理调度等智能监管功能，初步搭建了晋江市大气、水、土壤智能管控“一张图”的基本框架，创造生态文明建设的“晋江经验”，厚植全面建成小康社会的绿色底色和质量成色。',
            path: '/caseDetail/jjstyzt',
          },
          {
            imgUrl: '/img/case/case5.png',
            title: '海南省定安县城乡污水治理项目',
            desc: '本项目涉及定安县黄竹、龙湖、龙门、翰林等4个建制镇及其下辖的35个行政村(共计343个自然村)，覆盖面积5260K㎡，建成运行后将服务当地115695人，可削减污染物排放量:污水量1663m³/d，CODcr约260吨/年，氨氨约20吨/年。对实现定安县黄竹、龙湖、龙门、翰林4个地区的乡村振兴有着深远意义。',
            path: '/caseDetail/hnsdaxwszl',
          },
        ],
      },

      bannerOption: {
        initialSlide: 0, //默认第几张
        loop: false, //循环
        simulateTouch: false,
      },

      caseOption: {
        initialSlide: 0, //默认第几张
        slidesPerView: 2,
        spaceBetween: 25,
        loop: false, //循环
        simulateTouch: true,
        autoplayDisableOnInteraction: false, //触摸后再次自动轮播
        autoplay: 2000, //每张播放时长3秒，自动播放
        speed: 1000, //滑动速度
      },
    }
  },
  created() {
    let proId = this.$route.params.id
    this.swiperList = this.productData[proId].swiperList
    this.effectList = this.productData[proId].effectList
    this.characteristicData = this.productData[proId].characteristicData
    this.sceneData = this.productData[proId].sceneData
    this.effectBgList = this.randomNum(this.effectBgList,4)
    // this.caseData = this.productData[proId].caseData
  },
  methods:{
    // 随机生成arr数组中n个不重复的值
    randomNum(arr=[],n=0){
      let result = []
      while(result.length<n){
        let num = Math.floor(Math.random()*arr.length)
        if(!result.includes(arr[num])){
          result.push(arr[num])
        }
      }
      return result
    },
    swiperEnter(name){
      this.$refs[name].swiper.stopAutoplay()
    },
    swiperLeave(name){
      this.$refs[name].swiper.startAutoplay()
    },
    jumpTo,
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util.scss';
.banner-swiper {
  height: 488px;
  width: 100%;
  .banner-img {
    height: 100%;
    @include bgConfig;
    background-repeat: no-repeat;
    background-size: 1920px 560px;
    background-position: center bottom;
    color: #333333;
    .content {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .title {
        font-size: 20px;
        color: #0b68bf;
        margin-bottom: 16px;
      }
      .sub-title {
        font-size: 40px;
      }
      .desc {
        font-size: 16px;
        width: 680px;
        line-height: 30px;
        letter-spacing: 1px;
        margin: 16px 0 70px;
      }
    }
  }
}
.effect-wrap {
  padding-bottom: 56px;
}
.effect-slot {
  padding-top: 32px;
  min-height: 320px;
  width: 100%;
  color: #333333;
  .effect-inner {
    display: flex;
    justify-content: space-between;
  }
  .effect-item {
    flex: 1;
    margin-right: 24px;
    height: 288px;
    @include bgConfig;
    background-size: 100%;
    padding: 85px 20px 20px;
    box-shadow: 0px 4px 10px 0px rgba(236, 239, 244, 0.5);
    border-radius: 4px;
    border: 2px solid #fff;
    @include text-ellipsis-line(4);
    @include hoverTrans;
    &:last-child{
      margin-right: 0;
    }
    .effect-name {
      font-weight: bold;
      font-size: 24px;
      margin-bottom: 15px;
      text-align: center;
    }
    .effect-desc {
      font-size: 16px;
      opacity: 0.7;
      line-height: 24px;
      letter-spacing: 0.02px;
      @include text-ellipsis-line(5);
    }
  }
}
.characteristic-slot {
  display: flex;
  width: 100%;
  min-height: 388px;
  color: #333333;
  .characteristic-content {
    padding-top: 48px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .char-item {
      margin-right: 24px;
      flex: 1;
      height: 340px;
      text-align: center;
      background: #ffffff;
      border-radius: 4px;
      padding: 34px 24px;
      @include hoverTrans;
      &:last-child{
        margin-right: 0;
      }
      .char-name {
        margin: 34px auto 12px;
        font-size: 24px;
        font-weight: bold;
      }
      .char-desc {
        opacity: 0.7;
        text-align: left;
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 0.02px;
        @include text-ellipsis-line(3);
      }
    }
  }
}
.scene-slot {
  width: 100%;
  min-height: 520px;
  padding-top: 48px;
  .scene-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .linear {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 240px;
    opacity: 0.7;
    background: linear-gradient(180deg, rgba(10, 54, 95, 0.5), #0a365f);
  }
  .scene-item {
    margin-bottom: 24px;
    width: 588px;
    height: 240px;
    position: relative;
    color: #fff;
    @include bgConfig;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transition: all 0.3s linear;
    border-radius: 4px;
    overflow: hidden;
    &:hover {
      box-shadow: 0 2px 6px rgb(0 0 0 / 11%);
      background-size: 110% 110%;
    }
    .scene-name {
      top: 131px;
      position: absolute;
      font-size: 24px;
      font-weight: bold;
    }
    img {
      top: 75px;
      position: absolute;
    }
  }
}
.case-slot {
  width: 100%;
  min-height: 248px;
  .case-wrap {
    text-align: center;
    .item-btn {
      margin-top: 8px;
    }
    .inner {
      display: flex;
      .inner-right {
        padding-top: 48px;
        width: 100%;
        .case-swiper {
          width: 100%;
        }
        .case-item {
          width: 588px;
          height: 200px;
          background: #fff;
          border-radius: 4px;
        }
        .content {
          display: flex;
          padding: 24px;
          color: #333333;
          text-align: left;
          .img {
            width: 80px;
            height: 80px;
            margin-right: 24px;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;
          }
          .title {
            font-size: 20px;
            font-weight: bold;
          }
          .desc {
            margin-top: 8px;
            margin-bottom: 20px;
            @include text-ellipsis-line(3);
            font-size: 14px;
            opacity: 0.7;
            line-height: 24px;
            letter-spacing: 0.02px;
          }
        }
      }
    }
  }
}
</style>